import { Collapse, styled } from '@material-ui/core';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/ic-arrow-down.svg';
import { ReactComponent as ArrowUpIcon } from 'assets/icons/ic-arrow-up.svg';
import { TextButton } from '@ds/react-components';

export const Container = styled('div')({});

export const Collapsible = styled(Collapse)(({ theme }) => ({
  borderRadius: '6px',
  backgroundColor: theme.palette.xpl.background,
  padding: '10px 16px 10px 16px',
  marginBottom: '19px',
}));

const getArrowStyles = (theme) => ({
  width: '8px',
  height: '4px',
  color: theme.palette.xpl.secondary.default,
  marginLeft: '8px',
});

export const ExpandMoreIcon = styled(ArrowDownIcon)(({ theme }) => ({
  ...getArrowStyles(theme),
}));

export const ExpandLessIcon = styled(ArrowUpIcon)(({ theme }) => ({
  ...getArrowStyles(theme),
}));

export const RowRightTextButton = styled(TextButton)(({ theme }) => ({
  color: theme.palette.xpl.text.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
  textAlign: 'right',
}));
